/* eslint-disable no-unreachable */
/* eslint-disable indent */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { useLocation, useNavigate } from "react-router-dom";
import Moment from "react-moment";
import API from "../../../api";
import urls from "../../../api/urls";
import html2canvas from "html2canvas";
import {
  getStartAndEndDate,
  getCreatedDateNEnd,
  dateFormat_dmy,
  dateFormat_ymd,
  formatReceiverAddress,
  splitReceiverName,
  getCurretRole,
  printingFileTemplate,
  capitalise,
  capitalize,
} from "../../../utils";
import {
  Col,
  Row,
  Select,
  Menu,
  Dropdown,
  Spin,
  Input,
  Button,
  message,
  DatePicker,
  Form,
  Divider,
} from "antd";
import moment from "moment";
import axios from "axios";

import { shallowEqual, useDispatch, useSelector } from "react-redux";
import DraggerModal from "../modals/draggerModal";
import ViewBookingSummary from "../../ViewBookingSummary";
import {
  getBarcodeId,
  getSingleBooking,
} from "../../../actionsMethods/cashBookingMethods";
import { column } from "./column";
import TableContainer from "../../../components/TableContainer";
import search_icon from "../../../assests/images/search-icon.svg";
import print_icon from "../../../assests/images/master/print.svg";
import print_icon_white from "../../../assests/images/master/print-white.svg";

import "./AllBookingTable.scss";
import Smcs_Loader from "../../../assests/images/loader-new.gif";

import filter_icon from "../../../assests/images/master/sorting-filter.svg";
import Dox from "../../ViewBookingSummary/Dox";
import PrintBooking from "../../PrintBooking";
import Filters from "./Filters";
import constants from "../../../constants/constants";
import useCustomNavigate from "../../../components/customNavigationHook";
import { convertCurrentToPrevBookingData } from "../../../utils/bookingDataConverter";

const {
  UPLOAD_MANIFEST_FILE,
  GET_DOCUMENT_DETAILS_BY_AWB,
  GET_DOCUMENT_DETAILS_BY_AWB_CLIENT,
  GET_SINGEL_DOCUMENT_DETAILS_AWB,
  GET_SINGEL_DOCUMENT_DETAILS_AWB_BE,
  CANCEL_BOOKING,
  CANCEL_CREDIT_BOOKING,
  GET_CLIENT_INNO,
  GET_CLIENT_LIST_NEW,
  FETCH_CLIENT_RATE_EDIT,
} = urls;
const { RangePicker } = DatePicker;

const BookingTable = ({
  exportData = () => {},
  userList,
  convertNewToOldData,
  printPDFLabel,
  setLoading,
  loading,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useCustomNavigate();
  const history = useLocation();

  const [data, setData] = useState([]);
  const [oldAwbNum, setOldAwbNum] = useState(null);
  const [uploadModalvisible, setUploadModalvisible] = useState(false);
  // const [inputSearchValue, setInputSearchValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const [bookingType, setBookingType] = useState("");

  const backHistory = history?.state?.credit;

  const [pageNum, setPageNum] = useState(
    backHistory ? history?.state?.pageNo : 0
  );
  const [pageSize, setPageSize] = useState(
    backHistory ? history?.state?.pageSize : 20
  );
  const [currentPage, setCurrentPage] = useState(
    backHistory ? history?.state?.pageNo + 1 : 1
  );

  const debounceTimeout = useRef(null);
  const [searchValue, setSearchValue] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [printer, setPrinter] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [department, setDepartment] = useState([]);
  const [clientId, setClientID] = useState(null);
  const [departId, setDepartID] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [printDoc, setPrintDoc] = useState(null);
  const [printMultiDoc, setPrintMultiDoc] = useState([]);
  const currentEnv = process.env.REACT_APP_ENV;
  const [dateRange, setDateRange] = useState(
    backHistory
      ? history?.state
      : {
          startDate: moment().format(dateFormat_dmy),
          endDate: moment().format(dateFormat_dmy),
        }
  );
  const [documentDetails, setDocumentDetails] = useState([]);
  const [creditCharges, setCreditCharges] = useState(0);

  const selectedCompany =
    JSON.parse(localStorage.getItem("selectedCompany")) || null;
  const clientCompany = JSON.parse(localStorage.getItem("userinfo")) || null;

  const componentRef = useRef();
  const [printTrue, setPrintTrue] = useState(false);

  const { CLIENT_ADMIN } = constants?.ROLES;
  const [selectedClientNDeapart, setSelectedClientNDeapart] = useState(null);
  const userId = JSON.parse(localStorage.getItem("userId"));

  const [allFilters, setAllFilters] = useState({
    pageNo: null,
    pageSize: null,
    startDate: null,
    endDate: null,
    search: null,
    bookingType: "credit",
    status: null,
    docType: null,
    serviceType: null,
    travelBy: null,
    client: null,
    userSeleted: null,
    bulkPrint: null,
  });

  const viewBookingSummaryResponse = useSelector(
    (state) => state.appReducer.getSingleBookingReducer,
    shallowEqual
  );

  const {
    result: singleResult,
    error,
    fetching: loading2,
  } = viewBookingSummaryResponse;

  const getDepartMentQA = async (selectedClient, selectedDepartment) => {
    const currentDepartment = selectedDepartment
      ? [selectedDepartment?.item]
      : selectedClient?.department || [];

    if (selectedClient) {
      setDepartment(
        selectedClient?.department?.map((item, i) => ({
          key: i,
          value: i,
          label: getDepartmentContactName(item),
          item: item,
        }))
      );

      setSelectedClientNDeapart({ client: null, department: null });
    }
    const item = currentDepartment[0];
    const mergeName = getDepartmentContactName(item);

    form.setFieldsValue({
      department: mergeName,
    });
    if (selectedDepartment) {
      setDepartID(item?.ClientID);
    } else {
      setClientID(item?.ClientID);
    }
  };
  const getDepartmentContactName = (item) => {
    let departmentName =
      item?.Department && item?.Department !== ""
        ? item?.Department
        : "Default";

    let contactName =
      item?.ContactPerson && item?.ContactPerson !== ""
        ? "-" + item?.ContactPerson
        : "";

    if (contactName !== "" && departmentName === "Default") {
      departmentName = "";
      contactName =
        item?.ContactPerson && item?.ContactPerson !== ""
          ? item?.ContactPerson
          : "";
    }

    return departmentName + contactName;
  };

  const setClientDepartment = async (selectedClient, selectedDepartment) => {
    // form.setFieldsValue({
    //   department: null,
    // });

    const currentDepartment = selectedDepartment
      ? [selectedDepartment?.item]
      : selectedClient?.department || [];

    if (selectedClient) {
      setDepartment(
        selectedClient?.department?.map((item, i) => ({
          key: i,
          value: i,
          label: getDepartmentContactName(item),
          item: item,
        }))
      );
      setSelectedClientNDeapart({ client: null, department: null });
      form.setFieldsValue({
        // client: null,
        department: null,
      });
    }
    const item = currentDepartment[0];

    if (selectedDepartment) {
      setDepartID(item?.ClientID);
    } else {
      setClientID(item?.ClientID);
    }
  };

  useEffect(() => {
    const { state } = history || {};

    if (backHistory) {
      setAllFilters({ ...state, client: state?.departId || state?.client });
      getAllBookings({ ...state, client: state?.departId || state?.client });
      setFilteredInfo({
        travelBy: state?.travelBy ? [state?.travelBy] : [],
        bookingStatus: state?.status ? [state?.status] : [],
        userName: state?.userSeleted,
        type: [state?.docType, state?.serviceType], // Removes null/undefined values
      });
      // setClientID(state.client);
    }
  }, [history]);

  useEffect(() => {
    let temp = {
      pageNo: pageNum,
      pageSize: pageSize,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      search: searchValue,
      bookingType: "credit",
      status: null,
      docType: null,
      serviceType: null,
      travelBy: null,
      client: clientId,
      userSeleted: null,
    };
    setAllFilters(temp);
    if (!backHistory) {
      getAllBookings(temp);
    }
  }, []);

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    if (clientId) {
      let temp = {
        pageNo: pageNum,
        pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        search: null,
        // bookingType: filteredInfo?.bookingType?.[0] || null,
        bookingType: "credit",
        status: filteredInfo?.bookingStatus?.[0] || null,
        docType: filteredInfo?.type?.[0] || null,
        serviceType: filteredInfo?.type?.[1] || null,
        travelBy: filteredInfo?.travelBy?.[0] || null,
        client: clientId,
        userSeleted: filteredInfo?.userName?.[0] || null,
      };

      setAllFilters(temp);
      getAllBookings(temp);
    }
  }, [clientId]);

  useEffect(() => {
    if (departId) {
      let temp = {
        pageNo: pageNum,
        pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        search: null,
        // bookingType: filteredInfo?.bookingType?.[0] || null,
        bookingType: "credit",
        status: filteredInfo?.bookingStatus?.[0] || null,
        docType: filteredInfo?.type?.[0] || null,
        serviceType: filteredInfo?.type?.[1] || null,
        travelBy: filteredInfo?.travelBy?.[0] || null,
        client: departId,
        userSeleted: filteredInfo?.userName?.[0] || null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    }
  }, [departId]);

  const getClients = async () => {
    const companyId =
      JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;
    let res;
    if (currentEnv === "qa") {
      res = await API.Api(
        GET_CLIENT_LIST_NEW + companyId
      ).getWithPremiseHeader();
    } else {
      res = await API.Api(GET_CLIENT_INNO).getwithParams({
        company_id: companyId,
      });
    }

    if (res.status) {
      const response = res?.response?.data?.data || [];
      const clients = response?.map((e, i) => ({
        key: i,
        label: e?.ClientName?.toUpperCase(),
        value: e?.ClientName?.toUpperCase(),
        department: e?.Departments,
      }));
      // localStorage.setItem("allClients", JSON.stringify(clients) || null);
      setClientList(clients);

      const foundItem = clients?.find((item) => {
        return item?.department?.some((dept) => {
          return dept?.ClientID === history?.state?.client;
        });
      });

      const foundItemDepart = foundItem?.department?.find((dept) => {
        return dept?.ClientID === history?.state?.departId;
      });
      if (foundItem) {
        setDepartment(
          foundItem?.department?.map((item, i) => ({
            key: i,
            value: i,
            label: getDepartmentContactName(item),
            item: item,
          }))
        );
      }

      setSelectedClientNDeapart({
        client: foundItem,
        department: getDepartmentContactName(foundItemDepart),
      });
    } else {
      message.error("Something went wrong");
    }
  };

  const getAllBookings = async ({
    pageNo,
    pageSize,
    startDate,
    endDate,
    search,
    bookingType = "account",
    status,
    docType,
    serviceType,
    travelBy,
    client,
    userSeleted,
    bulkPrint,
    totalCharge,
  }) => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setLoading(true);

    let url = "";
    let data = bookingType;

    url =
      `${GET_DOCUMENT_DETAILS_BY_AWB_CLIENT}?limit=${pageSize}&page=${
        pageNo + 1
      }` +
      getCreatedDateNEnd(startDate ?? null, endDate ?? null, dateFormat_ymd);

    if (selectedCompany?.key || clientCompany?.companyId) {
      url += `&companyId=${selectedCompany?.key || clientCompany?.companyId}`;
    }

    if (data) {
      url += `&bookingType=${"credit"}`;
    }

    if (client) {
      url += `&clientId=${client}`;
    }

    if (status) {
      url += `&status=${
        status?.toLowerCase() === "booked" ? "Booked" : capitalize(status)
      }`;
    } else {
      url += `&status=${"Booked, Manifested"}`;
    }

    if (search) {
      url += `&documentNos=${search}`;
    }

    if (docType) {
      url += `&shipmentType=${docType}`;
    }

    if (serviceType) {
      url += `&deliveryPromise=${serviceType}`;
    }

    if (travelBy) {
      url += `&travelBy=${capitalize(travelBy)}`;
    }
    if (userSeleted) {
      let findUser = userList?.find((item) => item?.value == userSeleted);
      url += `&usernames=${findUser?.label}`;
    }

    let response;
    try {
      if (userSeleted) {
        response = await API.Api(url).getCustomHeader({
          "USER-ID": userSeleted,
          "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
        });
      } else {
        response = await API.Api(url).getWithPremiseHeader();
      }

      if (response?.status) {
        setLoading(false);
        let res = response?.response?.data;
        let response1Data = convertNewToOldData(res);

        const result = sanitizeData(response1Data);

        if (bulkPrint) {
          setSelectedRowKeys(result?.viewBookings?.map((e) => e.awbNumber));
        }

        setData(result);
      } else {
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      message.error(error?.message || "Internal server error.");
    }
  };
  function sanitizeData(obj) {
    for (let key in obj) {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        obj[key] === "" ||
        Number.isNaN(obj[key]) ||
        obj[key] === "NaN" ||
        Number.isNaN(obj[key])
      ) {
        obj[key] = 0;
      }
    }
    return obj;
  }

  const handleUpload = useCallback((val) => {
    setUploadModalvisible(true);
    setOldAwbNum(val.awbNumber);
  });

  function handleCancel() {
    setIsModalOpen(false);
    setIsSummaryModalOpen(false);
  }

  function MyComponent(dateToFormat) {
    return (
      <>
        <Moment format="DD/MM/YYYY">{dateToFormat}</Moment>
        <br />
        <Moment format="hh:mm A">{dateToFormat}</Moment>
      </>
    );
  }

  const getClientRates = async (awbNum) => {
    setLoading(true);

    let response = await API.Api(
      `${FETCH_CLIENT_RATE_EDIT}/sevasetu-reader/shipment/${awbNum}
`
    ).getWithNoToken();

    if (response?.status) {
      setLoading(false);
      const temp = response?.response?.data?.data?.charges;
      setCreditCharges(temp);
    } else {
      setLoading(false);
      setCreditCharges(0);
    }
  };

  const handleEyeButton = (b) => {
    setBookingType(b?.bookingType);
    setIsSummaryModalOpen(true);
    if (currentEnv === "qa" || currentEnv == "prod") {
      getDetails(b?.awbNumber);
    } else {
      dispatch(getSingleBooking(b?.awbNumber));
    }
    getClientRates(b?.awbNumber);
  };

  const getDetails = async (id) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB_BE + +id}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      let extract = response?.response?.data?.data?.items;
      let convert = convertCurrentToPrevBookingData(extract);
      setDocumentDetails(convert);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const statusFun = (val) => {
    const statusColors = {
      BOOKED: "stat-green",
      INITIATED: "blue",
      "In progress": "blue",
      Delivered: "stat-green",
      PACKETED: "darkBlue",
      SCANNED: "purple",
      "In transit": "yellow",
      MANIFESTED: "yellow",
      OUTSCANNED_TO_CP: "yellow",
    };

    const color = statusColors[val?.toUpperCase()] || "yellow";

    return <span className={color}>{val?.toUpperCase()}</span>;
  };

  function handleEdit(id, dateNTime) {
    localStorage.setItem("side_active", 3);

    const formattedDate = moment(dateNTime).format("DD-MM-YYYY");

    navigate(`/credit-booking-edit/${formattedDate}/${id}`, {
      state: {
        ...allFilters,
        departId: departId || history?.state?.departId,
        client: clientId || history?.state?.client,
        credit: true,
        retail: false,
      },
    });
  }

  /******************* Input search ******************************/

  const handleChangeSearch = (e) => {
    let currValue = e.target.value;
    if (currValue && isNaN(currValue)) {
      return;
    }
    setSearchValue(currValue);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      let temp = {
        pageNo: 0,
        pageSize: 20,
        startDate: moment().subtract(30, "days"),
        endDate: moment(new Date(), dateFormat_dmy),
        search: currValue.length ? currValue.trim() : null,
        bookingType: "credit",
        client: clientId,
        status: null,
        docType: null,
        serviceType: null,
        travelBy: null,
        userSeleted: null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    }, 900);
  };

  /******************* Type ******************************/

  function closeUploadModal(data) {
    setUploadModalvisible(false);
  }

  async function handleOK(data) {
    const temp = data?.map((val) => ({
      fileName: val?.response?.data?.filePath,
      fileId: val?.response?.data?.id,
    }));

    let response = await API.Api(UPLOAD_MANIFEST_FILE).postCustomHeader(temp, {
      "Awb-Number": oldAwbNum,
    });
    if (response) {
      setUploadModalvisible(false);
    }
  }

  function handlePageChange(pagination, filters, sorter) {
    setFilteredInfo(filters);
    window.scrollTo(0, 0);

    setPageSize(pagination?.pageSize);
    setPageNum(pagination?.current - 1);
    setCurrentPage(pagination?.current);

    setSearchValue(null);
    const hasFilters =
      filters?.bookingType?.[0] ||
      filters?.userName?.[0] ||
      filters?.bookingStatus?.[0] || // status
      filters?.type?.[0] ||
      filters?.type?.[1] ||
      filters?.travelBy?.[0];

    if (hasFilters) {
      setFilteredInfo(filters);
      let temp = {
        pageNo: pagination.current - 1,
        pageSize: pagination?.pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        client: clientId || history?.state?.departId || history?.state?.client,

        search: null, // search is null

        // bookingType: filteredInfo?.bookingType?.[0] || null,
        bookingType: "credit",
        status: filters?.bookingStatus?.[0] || null,
        docType: filters?.type?.[0] || null,
        serviceType: filters?.type?.[1] || null,
        travelBy: filters?.travelBy?.[0] || null,

        userSeleted: filters?.userName?.[0] || null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    } else {
      let temp = {
        pageNo: pagination?.current - 1,
        pageSize: pagination?.pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        client: clientId || history?.state?.departId || history?.state?.client,
        bookingType: "credit",

        search: null, // search is null

        status: null,
        docType: null,
        serviceType: null,
        travelBy: null,
        userSeleted: null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    }
  }

  const handleGenerateManifest = () => {
    navigate("/scan", {
      state: {
        ...allFilters,
        departId: departId || history?.state?.departId,
        client: clientId || history?.state?.client,
        credit: true,
        retail: false,
      },
    });
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleDateChange = (e, date) => {
    // e.preventDefault();
    setSearchValue(null);

    setDateRange({ startDate: date[0], endDate: date[1] });
    let temp = {
      pageNo: pageNum,
      pageSize,
      startDate: date[0] || moment(new Date(), dateFormat_dmy),
      endDate: date[1] || moment(new Date(), dateFormat_dmy),
      search: null,

      client: clientId,

      // bookingType: filteredInfo?.bookingType?.[0] || null,
      bookingType: "credit",
      status: filteredInfo?.bookingStatus?.[0] || null,
      docType: filteredInfo?.type?.[0] || null,
      serviceType: filteredInfo?.type?.[1] || null,
      travelBy: filteredInfo?.travelBy?.[0] || null,

      userSeleted: filteredInfo?.userName?.[0] || null,
    };
    getAllBookings(temp);
    setAllFilters(temp);
  };

  const handleDropdownVisibility = (visible) => {
    setDropdownVisible(visible);
  };

  // console.log(pageSize, "pageSize");

  const cancelBooking = async (awbNumber) => {
    setLoading(true);

    try {
      let response = await API.Api(
        CANCEL_CREDIT_BOOKING + awbNumber
      ).deleteHeader();

      if (response?.status) {
        setLoading(false);
        message.success("Booking cancelled successfully");
        let temp = {
          pageNo: pageNum,
          pageSize,
          startDate: null,
          endDate: null,
          search: searchValue,
          bookingType: "credit",
          status: null,
          docType: null,
          serviceType: null,
          travelBy: null,
          userSeleted: null,
        };
        setAllFilters(temp);

        getAllBookings(temp);
      } else {
        setLoading(false);
        message.error(
          response?.response?.data?.message || "Failed to cancel booking"
        );
      }
    } catch (error) {
      setLoading(false);
      message.error("Network error occurred while cancelling booking");
    }
  };

  useEffect(() => {
    if (error !== null) {
      setLoading(false);
      message.error("Internal server error");
      return;
    }
    if (singleResult && printTrue) {
      setTimeout(() => {
        setLoading(false);
        printHandle(); // Delayed to ensure the DOM is ready
      }, 100);
    }
  }, [singleResult, error]);

  // const printHandle = useReactToPrint({
  //   content: () => componentRef?.current || null,
  //   onBeforePrint: () => setPrintTrue(false),
  //   onAfterPrint: () => setPrintTrue(false),
  // });

  function printCallBack(params) {
    setPrintTrue(true);
    setLoading(true);
    dispatch(getSingleBooking(params));
  }

  useEffect(() => {
    const fetchPrinter = async () => {
      try {
        // STANDARD PORT FOR ZEBRA PRINTER
        const availablePrinters = await axios.get(
          "http://localhost:9100/available"
        );
        // console.log("availablePrinters: ", availablePrinters?.data?.printer[0]);
        setPrinter(availablePrinters?.data?.printer[0] || null);
        //  REQUEST TO INITIATE PRINTER
        await axios.post("http://localhost:9100/write", "", {
          headers: {
            "Content-Type": "text/plain",
          },
        });
      } catch (err) {
        // console.log("ZEBRA PRINTER NOT FOUND ");
        return;
      }
    };
    if (!printer) {
      fetchPrinter();
    }
  }, []);

  const handlePrinting = async (payload) => {
    let currentShipment = 1;

    // Processed address fields
    const processedAddress = formatReceiverAddress(
      payload?.addressDetails?.receiverAddressLine1,
      payload?.addressDetails?.receiverAddressLine2
    );

    const receiverName = splitReceiverName(
      payload?.addressDetails?.receiverName
    );

    const serviceMap = {
      "FAST TRACK": "FST",
      STANDARD: "STD",
      "VALUE PLUS": "VPLUS",
      VAYUQUICK: "VQ",
      VAYUQUICK_PRO: "VQPRO",
    };

    const rawService = payload?.serviceDetails?.service?.toUpperCase() || "";

    const speed = serviceMap[rawService] || rawService;

    const baseData = {
      ...receiverName,
      documentNumber: payload?.awbNumber,
      bookingType:
        payload?.shipmentDetails?.type?.toLowerCase() === "dox"
          ? "DOX"
          : "NDOX",
      bookingService: speed,
      bookindTravelType:
        payload?.serviceDetails?.travelBy?.toLowerCase() === "surface"
          ? "SUR"
          : "AIR",
      currentShipment: 1, // Replace this with appropriate logic for currentShipment
      senderName: payload?.shipmentDetails?.clientName,
      receiverMobileNumber: payload?.addressDetails?.receiverMobileNumber,
      receiverCity: payload?.addressDetails?.receiverCity,
      deliveryPincode: payload?.addressDetails?.receiverPincode,
      receiverAddressLine1: processedAddress[0] || "",
      recieverAddressLine2: processedAddress[1] || "",
      recieverAddressLine3: processedAddress[2] || "",
      recieverAddressLine4: processedAddress[3] || "",
      recieverAddressLine5: processedAddress[4] || "",
      recieverAddressLine6: processedAddress[5] || "",
      recieverAddressLine7: processedAddress[6] || "",

      senderAddress:
        payload?.addressDetails?.senderAddressLine1 +
        ", " +
        payload?.addressDetails?.senderCity,
      senderMobileNumber: payload?.addressDetails?.senderMobileNumber || "",
      totalShipments:
        parseInt(payload?.childShipmentDetails?.length || "0") + 1,
    };

    const printData = async (data) => {
      setLoading(true);
      try {
        const updatedTemplate = await printingFileTemplate()
          .then((res) =>
            res?.replace(/{{(.*?)}}/g, (_, key) => {
              return data[key?.trim()] || "";
            })
          )
          .catch((err) => console.log(err));

        const printingData = JSON.stringify({
          device: printer,
          data: updatedTemplate,
        });

        await axios.post("http://localhost:9100/write", printingData, {
          headers: {
            "Content-Type": "text/plain",
          },
        });
        setLoading(false);
      } catch (err) {
        setLoading(false);
        message.error(
          <>
            Please setup your printer if not done{" "}
            <a
              href="https://drive.google.com/file/d/1md-KX58IuOhQAi7h6VHpSxpAEGhOaaQ5/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              click here
            </a>{" "}
            for more info.
          </>
        );
        // console.log(err, "UNABLE TO PRINT");
      }
    };

    // Print for the main payload
    const mainData = {
      ...baseData,
      documentNumber: payload?.awbNumber,
    };

    await printData(mainData);

    // Check and print for child shipments
    if (
      payload?.childShipmentDetails &&
      Array.isArray(payload?.childShipmentDetails) &&
      payload?.childShipmentDetails?.length > 0
    ) {
      for (const child of payload.childShipmentDetails) {
        currentShipment = currentShipment + 1;
        const childData = {
          ...baseData,
          documentNumber: child?.childAwbNumber,
          currentShipment: currentShipment,
        };
        await printData(childData);
      }
    }
  };

  const printerCallBack = async (params) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB + +params}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      // setLoading(false);
      handlePrinting(response?.response?.data);

      return response?.response?.data;
      // setTotalLoad(response?.response?.data);
    } else {
      setLoading(false);

      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const clearFilters = () => {
    setFilteredInfo(null);
    let temp = {
      pageNo: 0,
      pageSize: 20,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      search: null,
      client: clientId || history?.state?.client,

      status: null,
      bookingType: "credit",
      docType: null,
      serviceType: null,
      travelBy: null,
      userSeleted: null,
    };
    setAllFilters(temp);
    getAllBookings(temp);
    window.history.replaceState({}, "", window.location.pathname);
  };

  const setLoadTable = (val) => {
    setLoading(val);
  };
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.disabled,
    }),
  };

  const printHandle = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      setLoading(false);
    },
    onAfterPrint: () => {
      setLoading(false);
    },
    onPrintError: () => {
      setLoading(false);
      console.error("An error occurred while printing.");
    },
  });

  const creditPrint = (id) => {
    setPrintMultiDoc([]);
    // setLoading(true);
    setPrintDoc(id);
  };

  function handlePrint() {
    let temp = {
      pageNo: pageNum,
      pageSize,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      search: null,
      bookingType: "credit",
      status: filteredInfo?.bookingStatus?.[0] || null,
      docType: filteredInfo?.type?.[0] || null,
      serviceType: filteredInfo?.type?.[1] || null,
      travelBy: filteredInfo?.travelBy?.[0] || null,
      client: clientId,
      userSeleted: filteredInfo?.userName?.[0] || null,
      bulkPrint: "bulkprint",
    };
    getAllBookings(temp);
    setAllFilters(temp);
  }

  function handleClearSelect(params) {
    if (params == "client") {
      setClientID(null);
      setDepartment(null);
      form.setFieldsValue({ department: null });
      let temp = {
        pageNo: pageNum,
        pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        search: null,
        bookingType: "credit",
        status: filteredInfo?.bookingStatus?.[0] || null,
        docType: filteredInfo?.type?.[0] || null,
        serviceType: filteredInfo?.type?.[1] || null,
        travelBy: filteredInfo?.travelBy?.[0] || null,
        client: null,
        userSeleted: filteredInfo?.userName?.[0] || null,
        bulkPrint: null,
      };

      getAllBookings(temp);
    } else {
      setDepartID(null);

      let temp = {
        pageNo: pageNum,
        pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        search: null,
        bookingType: "credit",
        status: filteredInfo?.bookingStatus?.[0] || null,
        docType: filteredInfo?.type?.[0] || null,
        serviceType: filteredInfo?.type?.[1] || null,
        travelBy: filteredInfo?.travelBy?.[0] || null,
        client: clientId,
        userSeleted: filteredInfo?.userName?.[0] || null,
        bulkPrint: null,
      };

      setAllFilters(temp);
      getAllBookings(temp);
    }
  }

  const isClientAdmin = getCurretRole();

  const handleCaptureAndSend = async () => {
    const element = componentRef.current;

    if (!element) {
      console.error("Ref element not found");
      return;
    }
    console.log(componentRef.current.innerHTML);

    try {
      const canvas = await html2canvas(element);
      const dataUrl = canvas.toDataURL("image/png");

      // 👉 Show the image in a new tab (for preview before sending)
      const newWindow = window.open();
      console.log(dataUrl);

      newWindow.document.write(
        `<img src="${dataUrl}" style="max-width:100%;" />`
      );

      // 👉 OR append to current page (for in-place preview)
      // const img = new Image();
      // img.src = dataUrl;
      // document.body.appendChild(img);

      // ❌ Stop before uploading
      return; // Remove or comment this once you're satisfied with the preview

      // The rest is for actual uploading if needed
      const blob = await (await fetch(dataUrl)).blob();
      const formData = new FormData();
      formData.append("file", blob, "printScreen.png");

      await axios.post("https://your-api-endpoint.com/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log("Image uploaded successfully");
    } catch (error) {
      console.error("Error capturing and sending image", error);
    }
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="print-only">
        <Dox
          // allAppData={singleResult}
          allAppData={documentDetails}
          // componentRef={componentRef}
          bookingType={bookingType}
        />
      </div>
      <ViewBookingSummary
        visible={isSummaryModalOpen}
        loading={loading2}
        // handleCancelBooking={handleCancelBooking}
        handleCancel={handleCancel}
        // allAppData={currentEnv == "qa" ? documentDetails : singleResult}
        allAppData={documentDetails}
        bookingType={bookingType}
        componentRef={componentRef}
        creditCharges={creditCharges}
      />

      <DraggerModal
        oldAwbNum={oldAwbNum}
        visible={uploadModalvisible}
        handleCancel={closeUploadModal}
        handleOk={handleOK}
      />

      <div className="table-container master-main-container">
        <Row
          className="row-one align-center"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <RangePicker
            value={
              dateRange.startDate && dateRange.endDate
                ? [
                    moment(dateRange.startDate, dateFormat_dmy),
                    moment(dateRange.endDate, dateFormat_dmy),
                  ]
                : null
            }
            format={dateFormat_dmy}
            onClick={(e) => e.stopPropagation()}
            disabledDate={(current) => disabledDate(current)}
            onChange={handleDateChange}
            // format={dateFormat_dmy}
            className="input-field-style"
            style={{ width: "220px" }}
          />
          {!isClientAdmin ? (
            <div>
              <Filters
                clientList={clientList}
                form={form}
                department={department}
                handleClearSelect={handleClearSelect}
                getDepartMentQA={getDepartMentQA}
                setClientDepartment={setClientDepartment}
                selectedClient={selectedClientNDeapart}
              ></Filters>
            </div>
          ) : null}
          <div>
            <Input
              value={searchValue}
              placeholder="Search by doc No."
              bordered
              maxLength={16}
              onChange={(e) => handleChangeSearch(e)}
              style={{
                borderRadius: "5px",
                height: "30px",
                fontSize: "12px",
                // marginRight: "10px",
                // width: "80%",
              }}
              suffix={<img src={search_icon} />}
            />
          </div>

          {!isClientAdmin && (
            <Col className="generate-manifest mr-1">
              <Button
                type="primary"
                onClick={handleGenerateManifest}
                className="save-btn"
                style={{ height: "28px" }}
                // disabled={!manifestFor}
              >
                CREATE MANIFEST
              </Button>
            </Col>
          )}

          <div className="generate-manifest">
            {selectedRowKeys.length === 0 && !clientId ? (
              <Button
                style={{ height: "28px" }}
                onClick={handlePrint}
                className="btn-style"
                type="dashed"
                //disabled={selectedRowKeys.length === 0}
              >
                <img src={print_icon} /> <b>&nbsp;PRINT</b>
              </Button>
            ) : (
              <Button
                style={{ height: "28px" }}
                type="primary"
                onClick={() => {
                  //navigate("/multi-print-booking", { state: selectedRowKeys })
                  setPrintDoc(null);
                  setLoading(true);
                  setPrintMultiDoc(selectedRowKeys);
                }}
                className="btn-style"
                disabled={selectedRowKeys.length === 0}
              >
                <img src={print_icon_white} /> <b>&nbsp;PRINT</b>
              </Button>
            )}
          </div>
          <Button
            style={{ height: "28px" }}
            type="primary"
            onClick={() => {
              //navigate("/multi-print-booking", { state: selectedRowKeys })
              exportData(allFilters);
            }}
            className="btn-style"
            disabled={selectedRowKeys.length !== 0}
          >
            <img src={print_icon_white} /> <b>&nbsp;EXPORT</b>
          </Button>
        </Row>

        <TableContainer
          rowKey={(record) => record?.awbNumber}
          rowSelection={rowSelection}
          onChange={handlePageChange}
          columns={column({
            MyComponent,
            statusFun,
            handleEdit,
            handleEditView: () => {}, // Add missing handleEditView parameter
            handleUpload,
            handleEyeButton,
            pageSize,
            pageNum,
            handleCancel: cancelBooking, // Now cancelBooking is correctly passed as handleCancel
            printCallBack,
            printerCallBack,
            printPDFLabel,
            // handleUserFilter,

            filteredInfo,
            clearFilters,
            setLoadTable,
            creditPrint,
            userList,
          })}
          scroll={{ x: 800 }}
          // showTotal={(total, range) =>
          //   `${range[0]}-${range[1]} of ${total} items`
          // }
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: data?.totalCount,
            itemRender: itemRender,
            pageSizeOptions: ["20", "50", "100"],
            showSizeChanger: true,
          }}
          dataSource={data?.viewBookings}
          headerClassName="header"
          className="view-table table-head-sticky"
        />
      </div>
      <div style={{ display: "none" }}>
        <PrintBooking
          currentDateRange={dateRange}
          ref={componentRef}
          id={printDoc}
          idList={printMultiDoc}
          loading={loading}
          setLoading={setLoading}
          callPrint={() => {
            printHandle();
            //setTimeout(() => handleCaptureAndSend(), 3000);
          }}
        />
      </div>
    </Spin>
  );
};

export default React.memo(BookingTable);
